import { AfterViewInit, Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { AuthenticationService } from './auth/authentication.service';
import { UsersService } from './_services/admin/users.service';
import { Subscription } from 'rxjs';
import { ApiService } from './_services/api.service';
import { ErrorUtil } from './_utilities/error';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent{
  title = 'template';
  menuMode = 'static';
  lightMenu = false;
  inputStyle: any = 'outlined';
  ripple!: boolean;
  isUserLoggedIn = false;
  addonFeature: any;
  refreshAIChatSubscription!: Subscription;

  /*=====================Validation Variables Start =========================== */
  public static emailPattern = "^[A-Za-z0-9._%+-]+@[a-z0-9.?-]+[\.]+[a-z]{2,}$";
  public static validQuantityPattern = "^(0|[1-9][0-9]*)$";
  public static validPricePattern = "^(0|[1-9][0-9]*)+(\.[0-9][0-9]?)?$";
  public static phonePattern = "^\\+?[0-9]{8,14}$";
  public static passwordPattern = "^[A-Za-z0-9_@./#&+-]{8,}$";
  public static strongPasswordRegx = "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\\$%&\\*()\-+=])(?=.{8,}).*$";
  public static fiterConditionPattern = "(\\(\\d\\s(AND|OR|or|and)\\s\\d\\))?\\s?(OR|AND|or|and)?\\s?(\\(\\d\\s(AND|OR|or|and)\\s\\d\\))?\\s?(OR|AND|or|and)?\\s?(\\(\\d\\s(AND|OR|or|and)\\s\\d\\))";
  public static taxConditionPattern = "^[0-9][0-9]?$|^100$";
  public static alphabetPattern = "^[a-zA-Z.\\s*]+$";
  public static numberPattern = "^[0-9]*$";
  public static fourNumberPattern = "[1-9][0-9]{3}";
  public static regex = /^\d+(\.\d{1,2})?$/i;
  public static calendarFormat = {
    lastDay: '[Yesterday]',
    sameDay: '[]',
    nextDay: '[Tomorrow]',
    lastWeek: 'DD/MM/YYYY',
    nextWeek: 'dddd',
    sameElse: 'L'
  };
  dailyJobRundown: any = false
  /*=====================Validation Variables Ends =========================== */

  constructor(
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private auth: AuthenticationService,
    private userService: UsersService,
    private apiService: ApiService,
    private errorUtil: ErrorUtil,
  ) {
   
    
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        // keep title in sync on every navigation
       
        // Redirect logic for login and dashboard
        if ((event.url === '/' || event.url.indexOf('login') >= 0) && this.auth.getToken()) {
          if (window.innerWidth < 720) {
            this.router.navigate(['/mobile']);
          } else {
            let currentPackage = localStorage.getItem('packageCode');
             this.apiService.getProfile().subscribe(profileResponse=>{
                if(profileResponse){
                  let profileInfo: any = profileResponse;
                
                  let currentProfileInfo: any = JSON.parse(this.auth.getProfileInfo());
                  currentProfileInfo['dataLoadPerformed'] = profileInfo.dataLoadPerformed; //update the local storage when the user comes back to the browser
                  localStorage.setItem('profile_info', btoa(JSON.stringify(currentProfileInfo)));

                  if (profileInfo.dataLoadPerformed === true || currentPackage == 'Old'){
                    //check for onboarding
                    let addonFeatures: any = JSON.parse(localStorage.getItem('addonFeatureList') || '[]');
                    console.log(addonFeatures, 'addonFeatures in app.component')
                    if (addonFeatures.indexOf("ONBOARD") >= 0 && currentPackage != 'Coffee_Pro'){
                      this.router.navigate(['/dashboard/onBoard/get-started']); 
                    }
                    else{
                      this.router.navigate(['/dashboard/jobOrders/all']);
                    }
                  }
                  else{
                    this.router.navigate(['/company-setup']);
                  }
                }
              }, (err) => {
                console.log(err)
               this.errorUtil.setErrorMessage(400, null ,  err.error, 'error',3000);
              
            });
            
          }
        } else {
          // this.refreshAIChatSubscription.unsubscribe();
        }
      }
    });
  }

  ngOnInit() {
    this.refreshAIChatSubscription = this.userService.refreshAIChatGlobal.subscribe(res => {
      this.getDailyJobRundown();
    });
    this.primengConfig.ripple = true;
    this.ripple = true;
  }
  getDailyJobRundown() {
    try {
      var feature :any= this.auth.getAIFeature();
      console.log(feature,"====feature====");
      const aiFeature = JSON.parse(feature);
      console.log(aiFeature,"====aiFeature====");
      
      this.isUserLoggedIn = true;
      this.dailyJobRundown = aiFeature.dailyJobRundown;
      console.log(this.dailyJobRundown,"====this.dailyJobRundown====");
      
    } catch (error) {
     console.error('Failed to parse AI feature JSON:', error);
      // Handle the error appropriately, e.g., set default values or show an error message
      this.isUserLoggedIn = false;
      this.dailyJobRundown = false;
    }
  }

  
}